export const ivory = 'rgba(250, 248, 235, 1)'
export const gray = 'rgba(91, 105, 106, 1)'
export const darkBlue = 'rgba(64, 96, 121, 1)'
export const lightBlue = 'rgba(142, 175, 190, 1)'
export const sage = 'rgba(196, 197, 166, 1)'